<template>
	<section class="py-5 box-layout-details" style="overflow:auto;height:100vh;">
        <div class="container">
            <div v-if="!isShowAnalytics" class="loader1">
                <div>
                    <div class="lds-ripple">
                    <div></div>
                    <div></div>
                    </div>
                </div>
            </div>
            <div v-if="isShowAnalytics" class="row">
                <div :key="sa.Uid" v-for="sa in items" class="col-lg-6 mb-3" @click="companyClicked(sa)">
                    <div class="card analytics-box-layout">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h4 class="text-c-gray">{{sa.Company}}</h4>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer bg-c-dark-blue">
                            <div class="row align-items-center">
                                <div class="col-lg-6">
                                    <div class="card-box-chart">
                                        <div class="icon-card-chart">
                                            <v-icon class="text-white" scale="2" name="comments"></v-icon>
                                        </div>
                                        <div class="icon-analytics-box">
                                            <h3>{{sa.UnreadCount}}</h3>
                                            <p>Unread Messages</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="card-box-chart">
                                        <div class="icon-card-chart">
                                             <v-icon class="text-white" scale="2" name="tasks"></v-icon>
                                        </div>
                                        <div class="icon-analytics-box">
                                            <h3>{{sa.DueTaskCount}}</h3>
                                            <p>Tasks Due</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-lg-6">
                                    <div class="card-box-chart">
                                        <div class="icon-card-chart">
                                            <v-icon class="text-white" scale="2" name="user-plus"></v-icon>
                                            
                                        </div>
                                        <div class="icon-analytics-box">
                                            <h3>{{sa.NewProspCount}}</h3>
                                            <p>New Prospects</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="card-box-chart">
                                        <div class="icon-card-chart">
                                            <v-icon class="text-white" scale="2" name="address-book"></v-icon>
                                        </div>
                                        <div class="icon-analytics-box">
                                            <h3>{{sa.ContactedProspCount}}</h3>
                                            <p>Contacted Prospects</p>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>  
<script>
import { db } from 'src/db'
import { mapState } from 'vuex'

	export default {
		name: "Dashboard",
		computed: {
			...mapState('firebase', ['user','prospects', 'convos'])
        },
        
        async created() {
            let teamRef = await db.collection(`Team`).doc(`/zzxOvpZGle9GsNlZqisB`).get();
            const teamCollectionData = teamRef.data();
            let testData = [];
            let teams = [];
            if (teamCollectionData && (teamCollectionData.hasOwnProperty(this.user.Uid))) {
                teams = teamCollectionData[this.user.Uid].Teams;
                teams.push(this.user.Uid);
                
            }else {
                teams.push(this.user.Uid);
            }
            let userCollectionData = [];
            let convoCollectionData = [];
            [userCollectionData,convoCollectionData] = await this.getUserAndConvoData(teams);
            

            // let userRef = await db.collection(`Users`).where('Uid', 'in', teams).get();
            // let userCollectionData = userRef.docs.map((doc) => {
            //     let data1 = { id: doc.id, ...doc.data() };
            //     return data1;
            // });



            // let convoRef = await db.collection(`Conversations`).where('Uid', 'in', teams).where('Unread', "==" ,1).get();


            // let convoRef = await db.collection(`Conversations`).where('Uid', 'in', teams).get();
            // let convoCollectionData = convoRef.docs.map((doc) => {
            //     let data1 = { id: doc.id, ...doc.data() };
            //     return data1;
            // });
            //eslint-disable-next-line
            // console.log(userCollectionData,convoCollectionData);
            for (let uindex = 0; uindex < userCollectionData.length;) {
                let undreadCount = 0;
                let fdata = convoCollectionData.filter(cn =>  cn.Uid == userCollectionData[uindex].Uid)
                for (let fi = 0; fi < fdata.length;) {
                    undreadCount = undreadCount + fdata[fi].Unread;
                    fi++;
                }
                
                let dueTaskList = [];
                // let newProspList = [];
                // let contacedProspList = [];
                let prospRef = await db.collection(`Users/${userCollectionData[uindex].id}/Prospects`).get();
                prospRef.docs.forEach(doc => {
                    if (doc.data().hasOwnProperty('Tasks') && doc.data().Tasks && doc.data().Tasks.length) {
                        doc.data().Tasks.forEach(element => {
                            if (element.Status == 'draft' && element.DueOn <= Date.now()) {
                                dueTaskList.push(element);
                            }
                        });
                    }
                    // if (doc.data().hasOwnProperty('Status') && doc.data().Status && doc.data().Status == 'New') {
                    //     newProspList.push(doc.data());
                    // }
                    // if (doc.data().hasOwnProperty('Status') && doc.data().Status && doc.data().Status == 'Contacted') {
                    //     contacedProspList.push(doc.data());
                    // }
                });
                testData.push({
                    "Company":userCollectionData[uindex].Company,
                    "Uid":userCollectionData[uindex].Uid,
                    "UnreadCount":undreadCount,
                    "DueTaskCount":dueTaskList.length,
                    // "ContactedProspCount":contacedProspList.length,
                    // "NewProspCount":newProspList.length

                });
                uindex++;
            }
            this.items = testData;
            this.isShowAnalytics = true;

        },
        methods: {
            async getUserAndConvoData(teams) {
                let userCollectionData = [];
                let convoCollectionData = [];
                if (teams.length > 10) {
                    const collectionPath = db.collection(`Users`);
                    const collectionPath1 = db.collection(`Conversations`);
                    let userbatches = [];
                    let convobatches = [];
                    while (teams.length) {
                        // firestore limits batches to 10
                        const batch = teams.splice(0, 10);
                        // add the batch request to to a queue
                        userbatches.push(
                            new Promise((response) => {
                                collectionPath.where('Uid','in',[...batch])
                                .get()
                                .then(results => response(results.docs.map(result => ({ id: result.id, ...result.data()}) )))
                            })
                        )
                        convobatches.push(
                            new Promise((response) => {
                                collectionPath1.where('Uid','in',[...batch])
                                .get()
                                .then(results => response(results.docs.map(result => ({ id: result.id, ...result.data()}) )))
                            })
                        )
                    }
                    // after all of the data is fetched, return it
                    await Promise.all(userbatches).then(content => {
                        var merged = [].concat.apply([], content);
                        userCollectionData = merged;
                    })
                    await Promise.all(convobatches).then(content => {
                        var merged = [].concat.apply([], content);
                        convoCollectionData = merged;
                    })
                }else {
                    let userRef = await db.collection('Users').where('Uid', 'in', teams).get();
                    userCollectionData = userRef.docs.map((doc) => {
                        let data1 = { id: doc.id, ...doc.data() };
                        return data1;
                    });

                    let convoRef = await db.collection('Conversations').where('Uid', 'in', teams).get();
                    convoCollectionData = convoRef.docs.map((doc) => {
                        let data1 = { id: doc.id, ...doc.data() };
                        return data1;
                    });
                }
                return [userCollectionData,convoCollectionData]
            },
            companyClicked(data) {
                // eslint-disable-next-line
                console.log(data);
                // let key = {Uid:data.Uid}
                // this.$emit('changeUser',key);
                this.$store.dispatch('firebase/clearMailsData');
                this.$store.dispatch("firebase/bindUserData", data.Uid)
				.then(() => {
					this.loaded = true;
                    // this.$router.push('Conversations')
				})
				.catch((err) => {
					//eslint-disable-next-line
					console.log(err);
				});
            }
        },
        data() {
			return {
				isShowAnalytics:false,
                items:[]
			}
		}
	}
</script>

<style scoped>
.card-box-chart {
    text-align: center;
}
.bg-c-gray {
    background-color: gray;
    color: white;
    border: none;
}
.bg-c-blue{
    background-color: #4680ff;
    color: white;
    border: none;
}
.bg-c-dark-blue{
    background-color: #002575;
    color: white;
    border: none;
}
#ad5e93
.text-c-gray {
    color: #595959;
}
.box-layout-details .card {
    box-shadow: 0 2px 10px -1px rgba(69, 90, 100, 0.3);
    margin-bottom: 30px;
    transition: box-shadow 0.2s ease-in-out;
    border: none;
}
.bg-c-purpal{
    background-color:#ad5e93;
    color: white;
    border: none;
}
.card-box-chart {
    display: flex;
    text-align: left;
    margin-bottom: 15px;
    align-items: center;
}
.icon-analytics-box h3 {
    font-size: 40px;
    margin-bottom: 0;
}
.icon-card-chart {
    font-size: 30px;
    height: 100%;
    margin-right: 0.8em;
}
.card-box-chart p {
    font-size: 17px;
    font-weight: 400;
    margin: 0px;
}
.loader1 {
position: fixed;
z-index: 1010;
top: 50%;
margin: auto;
left: 50%;
z-index: 1111;
}

.loader1:before {
content: "";
display: block;
position: fixed;
top: 0;
left: 0;
width: 100%;
min-height: 100%;
background-color: rgba(0, 0, 0, 0.3);
z-index: 1111;
}

.lds-ripple {
display: inline-block;
top: 50%;
position: relative;
width: 64px;
height: 64px;
}

.lds-ripple div {
position: absolute;
top: 50%;
border: 4px solid #000000;
opacity: 1;
border-radius: 50%;
animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
animation-delay: -0.5s;
}

@keyframes lds-ripple {
0% {
top: 28px;
left: 28px;
width: 0;
height: 0;
opacity: 1;
}
100% {
top: -1px;
left: -1px;
width: 58px;
height: 58px;
opacity: 0;
}
}
</style>